import { Link } from 'react-router-dom';
import SubscribeForm from '@/features/newsletter/components/SubscribeForm';

export default function Footer() {
  return (
    <footer className="no-print" style={{ borderTop: '1px solid var(--color-border)' }}>
      <div className="container-wide text-xs text-muted text-center py-10">
        <div className="mb-4 max-w-xs mx-auto">
          <p className="mb-2 text-accent font-bold">[ SUBSCRIBE ]</p>
          <SubscribeForm />
        </div>
        <div className="mb-2">
          <Link to="/terms" className="hover:underline">Terms of Service</Link>
          {' | '}
          <Link to="/privacy" className="hover:underline">Privacy Policy</Link>
        </div>
        &copy; {new Date().getFullYear()} :: Vladyslav Chebotarov :: All rights reserved
      </div>
    </footer>
  );
}
